<template>
  <layout>
    <template v-slot:header>
      <global-navigation></global-navigation>
    </template>

    <main v-if="hasPage" class="impact">
      <div v-if="slideshowImages" class="slideshow">
        <auto-flickity>
          <figure v-for="(image, i) in slideshowImages" :key="i">
            <img :src="image.wares" class="slideshow-image" :style="`--imgRatio:${(image.width / image.height)};`">  
          </figure>
        </auto-flickity>

        <div class="slideshow-overlay">
          <h1>CULTURE & IMPACT</h1>
        </div>
      </div>

      <div v-else-if="page.heroimage || page.herovideo" class="hero-video">
        <div class="video">
          <div class="vid-inner">
            <video v-if="page.herovideo" :src="page.herovideo" muted loop autoplay preload playsinline></video>
            <img v-else-if="page.heroimage" :src="page.heroimage.wares" :alt="page.heroimage.alt">
          </div>

          <div class="title">
            <h1>CULTURE & IMPACT</h1>
          </div>
        </div>
      </div>

      <section v-if="page.description">
        <rich-text 
          :class="['content']" 
          :content="page.description"
        />
      </section>

      <div class="impact-details" :class="{ 'extra-margin': !page.creditstext }">
        <vue-link
          v-for="(item, index) in page.impact_details"
          :key="item.url"
          :to="item.url"
          class="impact-list-item"
        >
          <article
            :class="getCardClass(index)"
          >
            <div class="image">
              <div class="inner">
                <figure class="figure" v-if="item.gridimage">
                  <img :src="item.gridimage['small-natural']" :alt="item.gridimage.alt" />
                </figure>
              </div>
            </div>

            <div class="text">
              <p class="subtitle">{{ item.subtitle }}</p>

              <h2>{{ item.title }}</h2>

              <span class="year">{{ item.year }}</span>
            </div>
          </article>
        </vue-link>
      </div>

      <section v-if="page.creditstext">
          <rich-text 
            :class="['content']" 
            :content="page.creditstext"
          />
        </section>
    </main>

    <template v-slot:footer>
      <global-footer :border="true"></global-footer>
    </template>
  </layout>
</template>

<script>
import PageMixin from '@/mixins/PageMixin'
import RichText from '@/components/RichText'
import AutoFlickity from '@/components/AutoFlickity'

export default {
  name: 'Page',
  mixins: [PageMixin],
  components: { RichText, AutoFlickity },
  computed: {
    slideshowImages() {
      if (this.page && this.page.slideshow && this.page.slideshow.length) {
        if (this.page.slideshow.length <= 3) {
          return this.page.slideshow.concat(this.page.slideshow)
        } else {
          return this.page.slideshow
        }
      }
      return null
    }
  },
  methods: {
    getCardClass(index) {
      const remainder = index % 2

      if (remainder === 0) {
        return 'image-right'
      } else {
        return 'image-left'
      }
    }
  }
}
</script>

<style scoped>
.hero-video {
  position: relative;
  padding: 0 2rem;
}

.hero-video .video {
  padding-bottom: 50%;
  border-radius: var(--br);
  overflow: hidden;
  background-color: rgba(255, 255, 255, .1);
  position: relative;
}

.hero-video .video .title {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
}

.hero-video .video h1 {
  font: var(--nord);
  color: white;
  font-size: 7rem;
}

.vid-inner {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
}

.vid-inner video,
.vid-inner img {
  object-fit: cover;
  object-position: center;
  width: 100%;
  height: 100%;
}

.content { 
  padding: 6rem 2rem;
  text-align: center;
  max-width: 1200px;
  margin: 0 auto;
}

.impact-details {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  padding: 0 2rem 0 2rem;
  grid-gap: 2rem;
  max-width: 1200px;
  margin: 0 auto 3rem auto;
  border-left: 1px dashed white;
  border-right: 1px dashed white;
}

.impact-details.extra-margin {
  padding: 0 2rem 10rem 2rem;
}

.impact-list-item {
  width: 100%;
  grid-column: span 1 / span 1;
  margin: 0 auto;
  border-bottom: 1px dashed white;
}

.image {
  width: 100%;
}

.title {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.text {
  display: flex;
  justify-content: space-between;
  text-transform: uppercase;
  color: white;
  font: var(--nord);
  padding: var(--p1);
}

.text .subtitle {
  width: 8ch;
  text-align: left;
}

.text .year {
  width: 8ch;
  text-align: right;
}

.text h2 {
  flex: 1;
  text-align: center;
}

.image .inner {
  width: 100%;
  padding-bottom: 70%;
  position: relative;
  overflow: hidden;
  border-radius: var(--br);
  display: block;
}

.image figure {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0px;
  left: 0px;
}

.image figure img {
  object-fit: cover;
  object-position: center;
  width: 100%;
  height: 100%;
}

.description {
  margin-top: 4rem;
}

.description p {
  font: var(--nord);
}

.slideshow h1,
.hero-video h1 {
  color: #fa3b41;
  text-align: center;
}

@media (max-width: 1000px) {
  .impact-details {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    padding: 0 2rem;
    grid-gap: 2rem;
    border: none;
  }

  .hero-video .video {
    padding-bottom: 170%;
  }

  .hero-video .video h1 {
    font-size: 5rem;
  }

  .impact-list-item {
    grid-column: span 2 / span 2;
  }

  .image {
    order: 1 !important;
  }
}

/*
Slideshow
*/
.slideshow {
  margin: 0 2rem;
  width: calc(100% - 4rem);
  position: relative;
  border-radius: var(--br);
  overflow: hidden;
  z-index: 4;
}

.slideshow .slideshow-image {
  display: block;
  height: 85vh;
  width: calc(85vh * var(--imgRatio));
}

.slideshow-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5vw 25vw;
  pointer-events: none;
  z-index: 5;
}

.slideshow-overlay h1 {
  font: var(--nord);
  color: #fa3b41;
  font-size: 7rem;
}

.slideshow-overlay img:first-child { display: block; }
.slideshow-overlay img:last-child { display: none; }

@media (max-width: 1000px) {
  .slideshow figure {
    width: 100%;
  }

  .slideshow .slideshow-image {
    display: block;
    height: 67.5vh;
    width: 100%;
    object-fit: cover;
    object-position: center;
    /*width: calc(67.5vh * var(--imgRatio));*/
  }

  .slideshow-overlay img {
    width: 72vw;
  }

  .slideshow-overlay img:first-child { display: none; }
  .slideshow-overlay img:last-child { display: block; }
}
</style>